import { render, staticRenderFns } from "./UserDataAndAverageBarChart.vue?vue&type=template&id=efd91698&"
import script from "./UserDataAndAverageBarChart.vue?vue&type=script&lang=ts&"
export * from "./UserDataAndAverageBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports